// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'


import TimeRange from './components/TimeRange.vue';
import eventBus from "../../../../../../util/eventBus";


(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args) => {
                invoke(eventName, args)
            }
            new Vue({
                el: model.dom,
                template: '<TimeRange :themeNum="themeNum" :lang="lang" :cusParam_timeData="cusParam_timeData" :cusParam_timeType="cusParam_timeType" :cusParam_timeMask="cusParam_timeMask" />',
                components: {
                    TimeRange
                },
                data: {
                    themeNum: "#5582F3",
                    lang: "zh_CN",
                    cusParam_timeData: [],
                    cusParam_timeType: "",
                    cusParam_timeMask: "",
                },
                destoryed() {
                    console.log('`')
                },
                mounted() {
                    //初始化控件配置信息
                    if (props.configItems) {
                        for (let x in props.configItems) {
                            this[props.configItems[x].key] = props.configItems[x].value;
                        }
                    }
                    if (props.themeNum) {
                        this.themeNum = props.themeNum;
                    }
                    if (props.lang) {
                        this.lang = props.lang;
                    }
                    if (props.data && props.data.hasOwnProperty('cusParam_timeData') && props.data.cusParam_timeData) {
                        this.cusParam_timeData = props.data.cusParam_timeData ? JSON.parse(props.data.cusParam_timeData) : [];
                    }
                    if (props.data && props.data.hasOwnProperty('cusParam_timeType') && props.data.cusParam_timeType) {
                        this.cusParam_timeType = props.data.cusParam_timeType ? JSON.parse(props.data.cusParam_timeType) : "2";
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if (props.themeNum) {
                            this.themeNum = props.themeNum;
                        }
                        if (!props.data) {
                            return
                        }
                        if (props.data && props.data.hasOwnProperty('cusParam_timeData') && props.data.cusParam_timeData) {
                            this.cusParam_timeData = props.data.cusParam_timeData ? JSON.parse(props.data.cusParam_timeData) : [];
                        }
                        if (props.data && props.data.hasOwnProperty('cusParam_timeType') && props.data.cusParam_timeType) {
                            this.cusParam_timeType = props.data.cusParam_timeType ? JSON.parse(props.data.cusParam_timeType) : "2";
                        }
                    })
                },
                methods: {}
            })
        })
    }

    // 注册自定义组件
    KDApi.register('mobTimeRange', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)
